import React from 'react';
import { Section } from './Shared';
import { HelpCircle } from 'lucide-react';
export const Plan = () => {
  return <>
      <Section className="bg-gray-50" data-id="element-294">
        <div className="max-w-4xl mx-auto" data-id="element-295">
          <h2 className="font-montserrat font-black text-3xl md:text-5xl uppercase leading-tight text-center mb-16" data-id="element-296">
            Tu plan claro para <span className="text-coral" data-id="element-297">empezar hoy</span>
          </h2>

          <div className="space-y-6 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-1 before:bg-coral/20" data-id="element-298">
            {[{
            week: 'Semana 1',
            text: 'Definir contenido + generar ideas'
          }, {
            week: 'Semana 2',
            text: 'Grabar y publicar primeros videos'
          }, {
            week: 'Semana 3',
            text: 'Sostener frecuencia y mejorar'
          }, {
            week: 'Semana 4',
            text: 'Consolidar hábito y ganar confianza'
          }].map((item, idx) => <div key={idx} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-299">
                <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-white bg-coral text-white font-bold shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow-md z-10" data-id="element-300">
                  {idx + 1}
                </div>
                <div className="w-[calc(100%-4rem)] md:w-[calc(50%-3rem)] bg-white p-6 rounded-2xl shadow-sm border border-gray-100" data-id="element-301">
                  <h3 className="font-montserrat font-bold text-coral text-lg mb-2" data-id="element-302">
                    {item.week}
                  </h3>
                  <p className="font-opensans font-bold text-xl text-gray-800" data-id="element-303">
                    {item.text}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </Section>

      <Section className="bg-white" data-id="element-304">
        <div className="max-w-3xl mx-auto" data-id="element-305">
          <h2 className="font-montserrat font-black text-3xl md:text-5xl uppercase leading-tight text-center mb-16" data-id="element-306">
            Lo que probablemente estás pensando
          </h2>

          <div className="space-y-6" data-id="element-307">
            {[{
            q: '“No tengo tiempo”',
            a: 'Solo necesitás 2–3 horas por semana'
          }, {
            q: '“No soy creativa”',
            a: 'Ya tenés las ideas listas'
          }, {
            q: '“Me da miedo exponerme”',
            a: 'El sistema te guía paso a paso'
          }].map((faq, idx) => <div key={idx} className="bg-gray-50 p-6 md:p-8 rounded-2xl border border-gray-200" data-id="element-308">
                <div className="flex items-start gap-4 mb-4" data-id="element-309">
                  <HelpCircle className="w-8 h-8 text-gray-400 shrink-0 mt-1" data-id="element-310" />
                  <h3 className="font-montserrat font-bold text-2xl text-gray-800 italic" data-id="element-311">
                    {faq.q}
                  </h3>
                </div>
                <div className="pl-12" data-id="element-312">
                  <p className="font-opensans font-bold text-xl text-coral bg-coral/10 inline-block px-4 py-2 rounded-lg" data-id="element-313">
                    {faq.a}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </Section>
    </>;
};